import { connect } from 'react-redux';
import { HomeSelector } from '../reducers/HomeReducer';
import { PlansSelector } from '../reducers/PlansReducer';
import { MyAccountSelector } from '../reducers/MyAccountReducer';
import Move from '../../components/Change/Move';
import MoveAction from '../actions/MoveAction';
import PlansAction from '../actions/PlansAction';
import { CheckoutSelector } from '../reducers/CheckoutReducer';

const mapStateToProps = state => ({
  address: HomeSelector.getFullAddress(state),
  isAddressSelected: HomeSelector.getIsAddressSelected(state),
  addressSearchError: HomeSelector.getError(state, 'MoveContainer'),
  customerInfo: MyAccountSelector.getCustomerInfo(state),
  availablePlans: PlansSelector.getAvailablePlans(state),
  selectedPlanId: PlansSelector.getSelectedPlanId(state),
  ufbAvailable: PlansSelector.getUfbAvailable(state),
  ufbReady: PlansSelector.getUfbReady(state),
  hasInstalledOnt: PlansSelector.getUfbReady(state),
  isCurrentPlanAvailable: PlansSelector.getCurrentPlanAvailable(state),
  connectionDateError: CheckoutSelector.getConnectionDateError(state),
  speedChangeOption: CheckoutSelector.getSpeedChangeOption(state)
});

const mapDispatchToProps = dispatch => ({
  setSelectedPlan: (id) => {
    dispatch(PlansAction.setSelectedPlan(id));
  },
  setMoveToPlan: (label) => {
    dispatch(MoveAction.setMoveToPlan(label));
  }
});

const MoveContainer = connect(mapStateToProps, mapDispatchToProps)(Move);

export default MoveContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/MoveContainer.js
 **/